'use strict';
const mmWidgets = require('../widgets/mm-widgets');
mmWidgets.fn.themeStyleFontPicker = function (mapThemeModel, fontPickerModel) {
	return mmWidgets.each(this, function () {
		const widget = this,
			themeNodeStyle = widget.attr('data-mm-theme-node-style'),
			themeAttrPath = widget.attr('data-mm-theme-font').split('.');
		mapThemeModel.addEventListener('themeJSONChanged', () => {
			const fontFamilyKey = mapThemeModel.getThemeAttribute(['node'], [themeNodeStyle, 'default'], themeAttrPath),
				fontFamily = fontPickerModel.getFontFamily(fontFamilyKey);
			widget.domElements[0].style.fontFamily = fontFamily;
			widget.text(fontFamilyKey);
		});
		widget.click(() => {
			fontPickerModel.pickFont()
			.then(fontFamilyKey => {
				mapThemeModel.overrideThemeAttribute(['node', themeNodeStyle].concat(themeAttrPath), fontFamilyKey || undefined);
			})
			.catch(() => {});
		});
	});
};

